/**
 * 拣货域枚举常量定义
 */

// 拣选任务状态
export enum PickingTaskStatus {
  NOT_STARTED = 'NOT_STARTED',     // 未开始
  IN_PROGRESS = 'IN_PROGRESS',     // 进行中
  COMPLETED = 'COMPLETED',         // 已完成
  CANCELLED = 'CANCELLED',         // 已取消
}

export const PickingTaskStatusOptions = [
  { value: PickingTaskStatus.NOT_STARTED, label: 'picking.taskStatus.notStarted', color: 'default' },
  { value: PickingTaskStatus.IN_PROGRESS, label: 'picking.taskStatus.inProgress', color: 'processing' },
  { value: PickingTaskStatus.COMPLETED, label: 'picking.taskStatus.completed', color: 'green' },
  { value: PickingTaskStatus.CANCELLED, label: 'picking.taskStatus.cancelled', color: 'red' },
];

// 任务来源
export enum TaskSource {
  WAVE = 'WAVE',                   // 波次生成
  MANUAL = 'MANUAL',               // 手工创建
}

export const TaskSourceOptions = [
  { value: TaskSource.WAVE, label: 'picking.taskSource.wave' },
  { value: TaskSource.MANUAL, label: 'picking.taskSource.manual' },
];

// 拣选明细状态
export enum PickingDetailStatus {
  PENDING = 'PENDING',             // 待拣
  PICKED = 'PICKED',               // 已拣
  SHORTAGE = 'SHORTAGE',           // 缺货
  REPLACED = 'REPLACED',           // 已替换
  CANCELED = 'CANCELED',           // 已取消（商品不再进行拣选，拣选数量为0）
  REPICKED = 'REPICKED',           // 重新拣选（调整了拣选数量）
  CONFIRMED_SHORT = 'CONFIRMED_SHORT', // 确认缺货（商品数量为0，实际拣选数量为0，已确认）
}

export const PickingDetailStatusOptions = [
  { value: PickingDetailStatus.PENDING, label: 'picking.detailStatus.pending', color: 'default' },
  { value: PickingDetailStatus.PICKED, label: 'picking.detailStatus.picked', color: 'green' },
  { value: PickingDetailStatus.SHORTAGE, label: 'picking.detailStatus.shortage', color: 'red' },
  { value: PickingDetailStatus.REPLACED, label: 'picking.detailStatus.replaced', color: 'orange' },
  { value: PickingDetailStatus.CANCELED, label: 'picking.detailStatus.canceled', color: 'default' },
  { value: PickingDetailStatus.REPICKED, label: 'picking.detailStatus.repicked', color: 'blue' },
  { value: PickingDetailStatus.CONFIRMED_SHORT, label: 'picking.detailStatus.confirmedShort', color: 'red' },
];

// 商品类型
export enum ItemType {
  NORMAL = 'NORMAL',               // 非称重
  WEIGHTED = 'WEIGHTED',           // 称重
}

export const ItemTypeOptions = [
  { value: ItemType.NORMAL, label: 'picking.itemType.normal' },
  { value: ItemType.WEIGHTED, label: 'picking.itemType.weighted' },
];

// 温层
export enum TemperatureZone {
  NORMAL = 'NORMAL',               // 常温
  CHILLED = 'CHILLED',             // 冷藏
  FROZEN = 'FROZEN',               // 冷冻
}

export const TemperatureZoneOptions = [
  { value: TemperatureZone.NORMAL, label: 'picking.temperatureZone.normal', color: 'default' },
  { value: TemperatureZone.CHILLED, label: 'picking.temperatureZone.chilled', color: 'blue' },
  { value: TemperatureZone.FROZEN, label: 'picking.temperatureZone.frozen', color: 'cyan' },
];

// 缺货原因
export enum ShortageReason {
  OUT_OF_STOCK = 'OUT_OF_STOCK',   // 库存不足
  ITEM_MISSING = 'ITEM_MISSING',   // 商品缺失
  OTHER = 'OTHER',                 // 其他
}

export const ShortageReasonOptions = [
  { value: ShortageReason.OUT_OF_STOCK, label: 'picking.shortageReason.outOfStock' },
  { value: ShortageReason.ITEM_MISSING, label: 'picking.shortageReason.itemMissing' },
  { value: ShortageReason.OTHER, label: 'picking.shortageReason.other' },
];

// 客户确认状态
export enum CustomerConfirmStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
}

export const CustomerConfirmStatusOptions = [
  { value: CustomerConfirmStatus.PENDING, label: 'picking.confirmStatus.pending', color: 'orange' },
  { value: CustomerConfirmStatus.CONFIRMED, label: 'picking.confirmStatus.confirmed', color: 'green' },
  { value: CustomerConfirmStatus.REJECTED, label: 'picking.confirmStatus.rejected', color: 'red' },
];
